import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { callAPI, createObject, IsSmallScreen, Method } from "../../../commonFunctions/CommonFunctions";
import { AllPermissions } from "../../../commonFunctions/PermissionManger";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import SwipeableDrawerForm from "../../../Components/DrawyerForm/DrawyerForm";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { resetDataComponent, storeDataComponent, updateDataComponent } from "../../../StateManagement/actions";
import PermissionDenied from "../../../commonFunctions/PermissionDenied";
import ConfirmDialog, { useConfirmDialog } from "../../../Components/Confirmation/ConfirmDialog";
import DrawyerPartPayment from "../../Notes/DrawyerPartPayment";
import { constant } from "lodash";


export const OverViewPartPayment: React.FC<any> = React.memo((props) => {
    AllPermissions.getInstance();
    //const { add, edit, remove, view } = AllPermissions.getPartPaymentsPermission;
    const { open, title, onConfirm, handleClose, openConfirmDialog, } = useConfirmDialog();
    const { showMessage } = useSnackbar();
    const dispatch = useDispatch()
    const params = useParams();
    const [openF, setOpen] = React.useState(false);
    const [partPaymentData, setPartPaymentData] = useState<any>([])
    const [resetLoad, setResetLoad] = useState(false)
    const id = params?.id;
    const { control, register, handleSubmit, setValue, reset } = useForm();
    const [formComponent, setFormComponent] = useState<any>()
    const isMobile = IsSmallScreen();
    const navigate = useNavigate();
    const location = useLocation(); 
    const resetTrigger = useSelector((state: any) => state.components?.partPaymentsGrid?.resetTrigger);
       useEffect(() => {
            const getInvoices = async () => {
                try {
                    setResetLoad(false)
                    const response: any = await callAPI(`Partpayment/byLead/${id}`, Method.GET, null, null);
                    setPartPaymentData(response || []);
                }
                catch (e) {
                }
            }
            getInvoices();
        }, [resetLoad])
    const columns: IColumns[] = [
        {
            header: "Date",
            fieldName: "date",
            type: 'date'
        },
        {
            header: "Area",
            fieldName: "area",
            type: 'default'
        },
        {
            header: "Amount",
            fieldName: "amount",
            type: 'default'
        },
        {
            header: "Description",
            fieldName: "description",
            tooltip: true,
            type: 'default'
        },
        {
            header: "Actions",
            fieldName: "actions",
            type: "action",

            actions: ["Edit", "Print", "Delete"].filter(Boolean),
            actionCallback: (action, row) => handleAction(action, row),

        },
    ];
    const handleAction = async (action: string, row: any) => {
        if (action === "Edit") {
            const form: any = <DrawyerPartPayment
                id={id}
                control={control}
                register={register}
                partPaymentId={row.id}
                workOrderId={row?.workOrderId}

                reset={reset}
                setValue={setValue}
                onCancel={() => { reset(); setOpen(false); setFormComponent(null) }}

            />
            setFormComponent(form)
            setTimeout(() => {
                setOpen(true)
            }, 10);
        } else if (action === "Delete") {
            openConfirmDialog("Delete this record?", () => handleDelete(row?.id))
        } else if (action === 'Print') {
            window.open(`${window.location.origin}/order/part-payment/print/${row?.id}`, "_blank");
        }
    }
    const handleDelete = async (id?: string | number) => {
        const response: any = await callAPI(`Partpayment`, Method.DELETE, null, id);
        dispatch(resetDataComponent('partPaymentsGrid'));
        setResetLoad(true)
        if (response?.success) {
            showMessage(response?.message, "success")
        }
        else {
            showMessage(response?.message || 'Something went wrong', "error")
        }
        handleClose()

    };
    useEffect(() => {
        const getPartPayments = async () => {
            try {
                setResetLoad(false)
                const response: any = await callAPI(`partPayments`, Method.GET, null, id);
                if (response.data) {
                    setPartPaymentData(response?.data || []);
                }
            }


            catch (e) {

            }
        }
        if (id) {
            getPartPayments();
        }
    }, [resetTrigger])
    useEffect(() => {
        const getPartPayments = async () => {
            try {
                setResetLoad(false)
                const response: any = await callAPI('PartPayments/lead', Method.GET, null, id);
                if (response.data) {
                    setPartPaymentData(response?.data || []);
                }
            }
            catch (e) {
            }
        }
        if (id) {
            getPartPayments();
        }
    }, [resetLoad])
    const setPartPaymentRequest = async (data: any) => {
        const request: any = {
            leadId: id,
            workOrderId: data?.workOrderId,
            amount: data?.amount,
            area: data?.area || "",
            description: data?.description,
            date: data?.date
        }
        try {
            const response = await callAPI(`Partpayment`, Method.PUT, request, data?.partPaymentId);
            return response || ""
        } catch (error) {

        }
    }
    const handleData = async (data: any) => {
        try {
            dispatch(storeDataComponent('PartPaymentSubmit', { loading: true }));
            const response: any = await setPartPaymentRequest(data);
            if (response && response?.message) {
                dispatch(resetDataComponent('partPaymentsGrid'));
                reset()
                setResetLoad(true)
                showMessage(response.message, response.success === true ? 'success' : 'error')
            } else if (response?.id) {
                dispatch(resetDataComponent('partPaymentsGrid'));
                setResetLoad(true)
                showMessage('Payment Created Successfully', 'success')
            }
        } catch (e: any) {
            showMessage(e.error);
            setResetLoad(false)
        }
        finally {
            dispatch(updateDataComponent('PartPaymentSubmit', { loading: false }));
        }
    }


    const source: any = {
        url: 'Partpayment/search',
        "page": 1,
        "pageSize": 10,
        "filter": [],
        "sort": []
    }
    const transFormData = (data: Array<any>) => {
        if (data) {
            data?.map((item: any) => {
                if (item?.description?.includes("@amount")) {
                    item.description = item?.description.replace("@amount", `( ${item?.amount}/ )`).replace("@area", `${item?.area}`)
                }
            })
            return data
        }
        return data
    }
    return (
        <Grid >
            <Grid container spacing={2} sx={{ p: 0, borderRadius: 5 }}>
                <Grid item xs={12}>
                    <WSDataGrid
                        isAccordian={true}
                        id="partPaymentsGrid"
                        title="Part Payments"
                        columns={columns}
                        data={partPaymentData}
                        transFormData={transFormData}
                        gridHeaderSx={{
                            backgroundColor: "#8B8000",
                            border: "1px solid #8B8000",
                        }}
                    // addButton={{ label: 'New', color: 'secondary', }}
                    // onAddButtonClick={handlePartPaymentClick}
                    />
                </Grid>

                <Grid item xs={12}>
                    {formComponent && <SwipeableDrawerForm isMobile={isMobile} anchor="right" title={'Part Payments'}
                        openForm={openF}
                        formComponent={<form onSubmit={handleSubmit(handleData)}>
                            {formComponent}
                        </form>}
                        onClose={() => { reset(); setOpen(false); setFormComponent(null) }}

                    />}
                </Grid>
            </Grid>
            <ConfirmDialog
                open={open}
                title={title}
                onConfirm={onConfirm}
                onClose={handleClose}
            />
        </Grid>

    );
});
